import { Icon, Utils } from '@treezor/design-system';

import { useI18nLocale } from '@/hooks/useI18nLocale';

type TOverviewItemProps = {
  label: string;
  value: number;
  hasWarning?: boolean;
};

export function UserWalletGlobalOverview({ label, value, hasWarning = false }: TOverviewItemProps) {
  const locale = useI18nLocale();

  return (
    <div className="rounded-200 border-secondary border-[1px] px-6 py-5 flex flex-col gap-1 bg-gradient-to-r from-blue-400/10 to-green-200/10">
      <span className="typo-body-regular-caption text-secondary">{label}</span>
      <div className="flex items-center justify-between gap-2">
        <span className="typo-number-semiBold-l text-secondary">{Utils.currencyFormater(locale, value, 'EUR')}</span>
        {hasWarning && <Icon name="warning" className="text-icon-warning" />}
      </div>
    </div>
  );
}
